export const resolveAssessmentClinicId = (
  selectedClinicId?: string | null,
  patientClinicId?: string | null,
  storedClinicId?: string | null,
): string => {
  if (selectedClinicId && selectedClinicId !== '__all_clinics__') return selectedClinicId;
  return patientClinicId || storedClinicId || '';
};

export const resolveAssessmentPatientId = (patient: any): string => String(
  patient?._id || patient?.id || patient?.patient_id || '',
);
